import React from 'react';
import AddAggrement from './AddAgreement';

const EditAgreement = ({ data, handleClick,setShowAgreement,getData,setSelectedAgreement }) => {
  return <AddAggrement data={data} handleClick={handleClick} setShowAgreement={setShowAgreement} getData={getData}
  setSelectedAgreement={setSelectedAgreement}
  />;
};

export default EditAgreement;
